import { j as t } from "./jsx-runtime-944c88e2.js";
import { D as r } from "./DropDownButton-d323264e.js";
import { R as m } from "./Ripple-5a8cf54c.js";
import { Icon as n } from "./icon.js";
import "react";
import "./index-efd35e77.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./index-64063129.js";
import "./theme-b013fa81.js";
import "./popup-da16fa2b.js";
import "./keys-2b65407d.js";
import "react-dom";
const R = (o) => {
  const i = o.iconName ? /* @__PURE__ */ t.jsxs("div", { children: [
    /* @__PURE__ */ t.jsx(n, { color: "secondary", icon: o.iconName, size: "lg", style: { paddingRight: "8px" } }),
    "props.text"
  ] }) : o.text;
  return /* @__PURE__ */ t.jsx(m, { children: /* @__PURE__ */ t.jsx(r, { ...o, rounded: "medium", text: i, children: o.children }) });
};
export {
  R as DropDownButton
};
